import { AxiosInstance } from 'axios';

import {
  AddonsAPIApiFactory,
  ClustersAPIApiFactory,
  EdgeConfigurationsAPIApiFactory,
  EdgeLocationsAPIApiFactory,
  EdgesV2BetaAPIApiFactory,
} from '@cast/openapi-omni';

import { AXIOS_CONFIGURATION } from '../constants';

export const OmniApiAdapter = (client: AxiosInstance) => {
  const clustersApi = ClustersAPIApiFactory(AXIOS_CONFIGURATION, '', client);
  const edgeLocationsApi = EdgeLocationsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );
  const edgesApi = EdgesV2BetaAPIApiFactory(AXIOS_CONFIGURATION, '', client);
  const edgeConfigurationsApi = EdgeConfigurationsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );
  const addonsApi = AddonsAPIApiFactory(AXIOS_CONFIGURATION, '', client);

  return {
    listEdgeLocations: edgeLocationsApi.edgeLocationsAPIListEdgeLocations,
    getEdgeLocationDetails: edgeLocationsApi.edgeLocationsAPIGetEdgeLocation,
    listClusters: clustersApi.clustersAPIListClusters,
    getClusterOnboardingScript: clustersApi.clustersAPIOnboardCluster,
    createEdgeLocation: edgeLocationsApi.edgeLocationsAPICreateEdgeLocation,
    getEdgeLocationOnboardingScript:
      edgeLocationsApi.edgeLocationsAPIOnboardEdgeLocation,
    getEdgeLocationOffboardingScript:
      edgeLocationsApi.edgeLocationsAPIOffboardEdgeLocation,
    updateEdgeLocation: edgeLocationsApi.edgeLocationsAPIUpdateEdgeLocation,
    deleteEdgeLocation: edgeLocationsApi.edgeLocationsAPIDeleteEdgeLocation,
    listEdgeNodes: edgesApi.edgesV2BetaAPIListEdges,
    createEdgeNode: edgesApi.edgesV2BetaAPICreateEdge,
    onboardEdgeInitd: edgeLocationsApi.edgeLocationsAPIOnboardEdgeInitd,
    listEdgeConfigurations:
      edgeConfigurationsApi.edgeConfigurationsAPIListEdgeConfigurations,
    createEdgeConfiguration:
      edgeConfigurationsApi.edgeConfigurationsAPICreateEdgeConfiguration,
    updateEdgeConfiguration:
      edgeConfigurationsApi.edgeConfigurationsAPIUpdateEdgeConfiguration,
    deleteEdgeConfiguration:
      edgeConfigurationsApi.edgeConfigurationsAPIDeleteEdgeConfiguration,
    getEdgeConfiguration:
      edgeConfigurationsApi.edgeConfigurationsAPIGetEdgeConfiguration,
    listAddons: addonsApi.addonsAPIListAddons,
  };
};
